import { useEffect, useRef } from "react";

export const useOutSideClick = (handler) => {
  const ref = useRef();
  useEffect(
    function () {
      function handleClick(e) {
        if (ref.current && !ref.current.contains(e.target)) {
          handler();
        }
      }
      function handleKeyDown(e) {
        if (e.key === "Escape") {
          handler();
        }
      }
      document.addEventListener("click", handleClick, true);
      document.addEventListener("keydown", handleKeyDown);

      return () => {
        document.removeEventListener("click", handleClick, true);
        document.removeEventListener("keydown", handleKeyDown);
      };
    },
    [handler],
  );

  return ref;
};
